import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/constants";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 360);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={buildWhatsAppLink()}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Hablanos por WhatsApp"
          data-testid="floating-whatsapp"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ type: "spring", stiffness: 220, damping: 18 }}
          className="fixed bottom-6 right-6 z-50 group"
        >
          <span className="relative inline-flex items-center justify-center w-14 h-14 rounded-full bg-whatsapp text-white shadow-2xl wa-pulse animate-float">
            <MessageCircle className="w-6 h-6" aria-hidden="true" />
          </span>
          <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-forest-900 text-bone text-[11px] uppercase tracking-widest2 font-semibold px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            Chateá con nosotros
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
